import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { mapDispatchToProps, mapStateToProps } from '../Store';
import { Link, useParams } from 'react-router-dom/cjs/react-router-dom.min';

import Layout from '../Components/Layout/Layout';
import PageTitle from '../Components/PageTitle';
import DrawingsTable from '../Components/DrawingsTable';

const PromotionDetailPage = ({ user, config, cmsSourceFirebase, promotions, loading, actions }) => {
    const { promo } = useParams();
    const [promotionDetail, setPromotionDetail] = useState(null);

    const page = {
        title: `Promotion`,
        className: 'promotions',
    };

    useEffect(async () => {
        const filteredPromo = promotions?.promotionsDetail.filter((promotion) => promo === promotion?.directory);
        if (filteredPromo.length === 0) {
            await actions.promotionsActions.getPromotionsDetail({ promotion: promo });
        }
    }, []);

    useEffect(() => {
        const filteredPromo = promotions?.promotionsDetail.filter((promotion) => promo === promotion?.directory);
        setPromotionDetail(filteredPromo[0]);
    }, [promotions?.promotionsDetail.length]);

    const CTA = () => {
        if (user.loggedIn) {
            return (
                <Link to='/enter' className='theme-btn theme-btn-solid-yellow theme-btn-lg'>
                    Enter your Ticket
                </Link>
            );
        } else {
            return (
                <Link to='/login' className='theme-btn theme-btn-solid-yellow theme-btn-lg'>
                    Login
                </Link>
            );
        }
    };

    const promoSection = (title, description) => (
        <div className='sub-section'>
            <h3 className='sub-title'>{title}</h3>
            <div className='description' dangerouslySetInnerHTML={{ __html: `${description}` }}></div>
        </div>
    );

    const promoPrizes = (prizes, disclaimer) => {
        return (
            <div className='sub-section prizes'>
                {prizes.map(({ name, image, winner, description }, idx) => (
                    <div key={idx} className='prize'>
                        <div className='prize-img-container'>
                            <img src={image} className='img-fluid' alt={name} />
                        </div>
                        <div className='prize-info'>
                            <h3 className='sub-title'>{name}</h3>
                            <p dangerouslySetInnerHTML={{ __html: winner }} />
                            <div className='description' dangerouslySetInnerHTML={{ __html: description }} />
                        </div>
                    </div>
                ))}
                {disclaimer && <div className='prize-disclaimer' dangerouslySetInnerHTML={{ __html: disclaimer }} />}
            </div>
        );
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            {loading.actions['getPromotionsDetail'] ? (
                <div className='loading-icon ellipses' />
            ) : (
                promotionDetail && (
                    <>
                        <div className='page-info'>
                            <PageTitle title={promotionDetail?.title} />
                        </div>
                        <div className='promo-detail'>
                            <div className='about'>
                                <div className='promo-img-container'>
                                    <img src={promotionDetail?.images?.small} alt={promotionDetail?.title} className='promo-img' />
                                </div>
                                <div className='description'>
                                    <div className='mb-3' dangerouslySetInnerHTML={{ __html: `${promotionDetail?.short_description}` }}></div>
                                    <CTA />
                                </div>
                            </div>

                            {promotionDetail?.prizes && promoPrizes(promotionDetail?.prizes, promotionDetail?.prizes_disclaimer)}

                            <div className='promo-drawings'>
                                <DrawingsTable promotionId={promo} excludes={['prizes']} loginLink={true} />
                            </div>

                            {promotionDetail?.eligible_games && promoSection('Eligible Games', promotionDetail?.eligible_games)}

                            {promotionDetail?.how_to_enter && promoSection('How to Enter', promotionDetail?.how_to_enter)}

                            {promotionDetail?.official_rules && promoSection('OFFICIAL RULES', promotionDetail?.official_rules)}

                            {promotionDetail?.faqs && promoSection('FAQs', promotionDetail?.faqs)}
                        </div>
                    </>
                )
            )}
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PromotionDetailPage);
